import { config } from '@/config'
import { UiButton } from '@/ui/UiButton'

export default function AppErrorBoundaryFallback({
  onReset,
}: {
  onReset: () => void
}) {
  return (
    <div className='bg-background mx-auto flex size-full h-full flex-1 flex-col items-center justify-center gap-4 px-4 text-center'>
      <img
        src='/branding/logo-large-dark.svg'
        alt={config.VITE_APP_NAME}
        className='hidden w-60 dark:block'
      />
      <img src='/branding/logo-large.svg' alt='' className='w-60 dark:hidden' />
      <h2 className='typography-m3-title-large text-foreground mt-4 font-bold'>
        Something bad happened in the app.
      </h2>
      <p className='text-muted-foreground typography-m3-body-large'>
        We already know about this issue and are working on a fix. Please try
        again later.
      </p>
      <UiButton variant='outline' size='lg' className='mt-2' onClick={onReset}>
        Reload
      </UiButton>
    </div>
  )
}
